import { EditOutlined, EyeFilled, PlusOutlined } from "@ant-design/icons";
import { Button, Space, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ApiURL } from "../../../../services/apiConstants";
import { post } from "../../../../services/services";

const ListEquipContainingLog = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const userData = JSON.parse(localStorage.getItem("user_data"));
  const shipId = userData?.data?.ship_details?.ship_id;
  const designation = userData?.data?.designation;

  const LIST_API = async () => {
    setLoading(true);

    const FORM_DATA = new FormData();
    FORM_DATA.append("ship_id", shipId);

    const res = await post(ApiURL.list_ods_record, FORM_DATA);

    if (res?.status == true) {
      setData(res.data || []);
    } else {
      setData([]);
    }

    setLoading(false);
  };

  useEffect(() => {
    LIST_API();
  }, []);

  const columns = [
    {
      title: "Equipment",
      dataIndex: "equipment",
      align: "center",
    },
    {
      title: "Location upon Board",
      dataIndex: "location_on_board",
      align: "center",
    },
    {
      title: "Year of Installation",
      dataIndex: "year_of_installation",
      align: "center",
    },
    {
      title: "Refrigerant Type",
      dataIndex: "refrigerant_type",
      align: "center",
    },

    {
      title: "Action",
      align: "center",
      render: (_, record) => (
        <Space>
          <Tooltip title="View Record">
            <Button
              type="primary"
              size="small"
              icon={<EyeFilled />}
              onClick={() =>
                navigate(`/view-equip-containing-log/${record?.ods_id}`)
              }
            />
          </Tooltip>

          <Tooltip title="Edit Record">
            <Button
              type="primary"
              size="small"
              icon={<EditOutlined />}
              onClick={() =>
                navigate(`/edit-equip-containing-log/${record?.ods_id}`)
              }
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <h2 style={{ margin: 0 }}>Equip Containing Log</h2>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
        }}
      >
        <Space>
          <Button
            type="primary"
            style={{ marginLeft: "10px" }}
            onClick={() => window.open("/ods.pdf", "_blank")}
          >
            Guideline
          </Button>
        </Space>
        <Space>
          <Button
            icon={<PlusOutlined />}
            type="primary"
            className="save_btn"
            onClick={() => navigate("/add-equip-containing-log")}
          >
            Add Equip Containing Log
          </Button>
        </Space>
      </div>

      <Table
        bordered
        loading={loading}
        columns={columns}
        dataSource={data}
        rowKey="ods_id"
        className="custom-table"
        pagination={{ pageSize: 10 }}
      />
    </>
  );
};

export default ListEquipContainingLog;
